import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAgentAPIService } from "service/core/AgentAPIService";
import IndieStaticSelect from "./forms/IndieStaticSelect";

export const BillingPeriodSelect = ({ agent, receipt = false, payment = true, noLabel, ...params }) => {

    const { t } = useTranslation();
    const agentApi = useAgentAPIService();
    const [billingPeriods, setBillingPeriods] = useState([]);

    useEffect(() => {
        if (agent) {

            if(receipt===true) {
                agentApi.getReceiptBillingPeriods(agent.id || agent).then((response) => {
                    setBillingPeriods(response.data.map((o) => ({ "value": o.id, "label": t(o.description), })));
                });
            }
        }
    }, [agent, receipt]);
    
    return (
        <IndieStaticSelect
            {...params}
            options={billingPeriods}
            label={noLabel ? "" : t("label.form.billingPeriod")}
            sx={{width: 250}}
            />
    );
};
